import React, { lazy } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

// Routes
import PublicRoute from './routes/public';
import PublicContentRoute from './routes/PublicContent';
import CallbackRoute from './routes/callback';
import DoctorRoute from './routes/doctor';
import PatientRoute from './routes/patient';
import ClinicRoute from './routes/clinic';
import AdminRoute from './routes/admin';
import ConferenceRoute from './routes/conferenceRoute';

// Page Components
const AsyncLogin = lazy(() => import('./containers/login/index'));
const AsynAboutUs = lazy(() => import('./containers/common/AboutMoeen'));
const AsyncTermsAndConditions = lazy(() => import('./containers/common/TermsAndCondtions'));
const AsyncPrivacyAndPolicy = lazy(() => import('./containers/common/PrivacyAndPolicy'));
const AsynAboutUsAr = lazy(() => import('./containers/common/AboutMoeenAr'));
const AsyncTermsAndConditionsAr = lazy(() => import('./containers/common/TermsAndCondtionsAr'));
const AsyncPrivacyAndPolicyAr = lazy(() => import('./containers/common/PrivacyAndPolicyAr'));
const AsyncSearchPrescription = lazy(() => import('./containers/searchPrescription/OpenPrescription'));

//Authentication Pages
const AsyncSignUp = lazy(() => import('./containers/signup/index'));
const AsyncForgotPassword = lazy(() => import('./containers/forgotPassword/index'));
const AsyncResetPassword = lazy(() => import('./containers/resetPassword/index'));
const AsyncVerifyAccount = lazy(() => import('./containers/verifyAccount/index'));

//DOCTOR
const AsyncDoctorSchedules = lazy(() => import('./containers/doctor/doctorSchedules/index'));
const AsyncDoctorAppointments = lazy(() => import('./containers/doctor/doctorAppointments/index'));
const AsyncDoctorUploads = lazy(() => import('./containers/common/fileUploads/index'));
const AsyncDoctorProfile = lazy(() => import('./containers/doctor/doctorProfile/index'));
const AsyncDoctorInvites = lazy(() => import('./containers/doctor/doctorInvites/index'));
const AsyncDoctorSettings = lazy(() => import('./containers/doctor/doctorSettings/index'));

//CLINIC
// const AsyncClinicDashboard = lazy(() => import("./containers/clinic/index"));
// PATIENT
const AsyncAppointments = lazy(() => import('./containers/patient/dashboard/index'));
const AsyncPatientSettings = lazy(() => import('./containers/patient/patientSettings/index'));
const AsyncPatientProfile = lazy(() => import('./containers/patient/patientProfile/index'));
const AsyncPatientUploads = lazy(() => import('./containers/common/fileUploads/index'));
const AsyncPatientAppointments = lazy(() => import('./containers/common/appointments/index'));
const AsyncWaitingRoom = lazy(() => import('./containers/common/waitingroom/index'));
const AsyncPatientSuccess = lazy(() => import('./containers/common/bookAppointment/components/PaymentSuccess'));
const AsyncPatientFailure = lazy(() => import('./containers/common/bookAppointment/components/PaymentFailure'));

// CLINIC
const AsyncClinicDashboard = lazy(() => import('./containers/clinic/dashboard/index'));
const AsyncCreatePatient = lazy(() => import('./containers/clinic/createPatient/index'));
const AsyncDoctorSchedule = lazy(() => import('./containers/common/doctorSchedule/index'));
const AsyncBookAppointment = lazy(() => import('./containers/common/bookAppointment/index'));
const AsyncPatientsList = lazy(() => import('./containers/clinic/patientslist/index'));
const AsyncClinicAppointments = lazy(() => import('./containers/common/appointments/index'));
const AsyncClinicProfile = lazy(() => import('./containers/clinic/profile/index'));
const AsyncClinicSettings = lazy(() => import('./containers/clinic/clinicSettings/index'));

// ADMIN
const AsyncAdminDashboard = lazy(() => import('./containers/admin/dashboard/index'));
const AsyncAdminCreateUsers = lazy(() => import('./containers/admin/createUsers/index'));
const AsyncAdminUsers = lazy(() => import('./containers/admin/users/index'));
const AsyncAdminAdvice = lazy(() => import('./containers/admin/advice/index'));
const AsyncAdminReports = lazy(() => import('./containers/admin/reports/index'));
const AsyncAdminSettings = lazy(() => import('./containers/admin/adminSettings/index'));
const AsyncDashboardAppointments = lazy(() => import('./containers/common/appointments/index'));
const AsyncSuccessCalls = lazy(() => import('./containers/admin/dashboardSuccessfulVideoCall/index'));
const AsyncNewRegisteredPatients = lazy(() => import('./containers/admin/dashboardNewRegisteredPatients/index'));

// CONFERENCE
const AsyncConferenceLayout = lazy(() => import('./containers/conference/index'));
const AsyncConferenceSettings = lazy(() => import('./containers/conference/ConferenceSetting'));
const AsyncConferenceAccess = lazy(() => import('./containers/conference/ConferenceAccess'));
const AsyncTestSettings = lazy(() => import('./containers/conference/components/test'));

const Routes = ({ props }) => {
    return (
        <Router>
            <Switch>
                <PublicRoute path="/" exact component={AsyncLogin} {...props} />
                <PublicContentRoute path="/about-us" exact component={AsynAboutUs} {...props} />
                <PublicContentRoute path="/privacy-and-policy" exact component={AsyncPrivacyAndPolicy} {...props} />
                <PublicContentRoute path="/terms-and-conditions" exact component={AsyncTermsAndConditions} {...props} />
                <PublicContentRoute path="/about-us-ar" exact component={AsynAboutUsAr} {...props} />
                <PublicContentRoute path="/privacy-and-policy-ar" exact component={AsyncPrivacyAndPolicyAr} {...props} />
                <PublicContentRoute path="/terms-and-conditions-ar" exact component={AsyncTermsAndConditionsAr} {...props} />
                <PublicRoute path="/sign-up" exact component={AsyncSignUp} {...props} />
                <PublicRoute path="/forgot-password" exact component={AsyncForgotPassword} {...props} />
                <PublicRoute path="/reset-password" exact component={AsyncResetPassword} {...props} />
                <PublicRoute path="/verify-account" exact component={AsyncVerifyAccount} {...props} />
                <CallbackRoute path="/get-prescription/:id" exact component={AsyncSearchPrescription} {...props} />

                <CallbackRoute path="/payment-success/:id" exact component={AsyncPatientSuccess} {...props} />
                <CallbackRoute path="/payment-failure/:id" exact component={AsyncPatientFailure} {...props} />
                <CallbackRoute path="/conference-access/:token/:sub" exact component={AsyncConferenceAccess} {...props} />

                {/* AFTER LOGIN  */}
                <DoctorRoute path="/doctor-schedules" exact component={AsyncDoctorSchedules} {...props} />
                <DoctorRoute path="/doctor-appointments" exact component={AsyncDoctorAppointments} {...props} />
                <DoctorRoute path="/doctor-uploads" exact component={AsyncDoctorUploads} {...props} />
                <DoctorRoute path="/doctor-profile" exact component={AsyncDoctorProfile} {...props} />
                <DoctorRoute path="/doctor-invites" exact component={AsyncDoctorInvites} {...props} />
                <DoctorRoute path="/doctor-settings" exact component={AsyncDoctorSettings} {...props} />
                <PatientRoute path="/patient-dashboard" exact component={AsyncPatientAppointments} {...props} />
                <PatientRoute path="/doctor-booking" exact component={AsyncDoctorSchedule} {...props} />
                <PatientRoute path="/book-appointment/:dId" exact component={AsyncBookAppointment} {...props} />
                <PatientRoute path="/patient-settings" exact component={AsyncPatientSettings} {...props} />
                <PatientRoute path="/patient-profile" exact component={AsyncPatientProfile} {...props} />
                <PatientRoute path="/patient-uploads" exact component={AsyncPatientUploads} {...props} />

                <ClinicRoute path="/clinic-dashboard" exact component={AsyncClinicDashboard} {...props} />
                <ClinicRoute path="/create-patient" exact component={AsyncCreatePatient} {...props} />
                <ClinicRoute path="/create-patient/:pId" exact component={AsyncCreatePatient} {...props} />
                <ClinicRoute path="/doctor-schedule/:pId" exact component={AsyncDoctorSchedule} {...props} />
                <ClinicRoute path="/clinic/book-appointment/:dId/:pId" exact component={AsyncBookAppointment} {...props} />
                <ClinicRoute path="/patients-list" exact component={AsyncPatientsList} {...props} />
                <ClinicRoute path="/appointments" exact component={AsyncClinicAppointments} {...props} />
                <ClinicRoute path="/edit-profile" exact component={AsyncClinicProfile} {...props} />
                <ClinicRoute path="/clinic-settings" exact component={AsyncClinicSettings} {...props} />
                {/* <ClinicRoute
                path="/patient-waiting-room/:id"
                exact
                component={AsyncWaitingRoom}
                {...props}
            /> */}

                <AdminRoute path="/admin-dashboard" exact component={AsyncAdminDashboard} {...props} />
                <AdminRoute path="/admin-createusers" exact component={AsyncAdminCreateUsers} {...props} />
                <AdminRoute path="/admin-users" exact component={AsyncAdminUsers} {...props} />
                <AdminRoute path="/admin-users/:profile" exact component={AsyncAdminUsers} {...props} />
                <AdminRoute path="/admin-appointments" exact component={AsyncDashboardAppointments} {...props} />
                <AdminRoute path="admin-appointments/:profile" exact component={AsyncDashboardAppointments} {...props} />
                <AdminRoute path="/admin-advice" exact component={AsyncAdminAdvice} {...props} />
                <AdminRoute path="/admin-reports" exact component={AsyncAdminReports} {...props} />
                <AdminRoute path="/admin-settings" exact component={AsyncAdminSettings} {...props} />
                <AdminRoute path="/admin-successfulvideocalls" exact component={AsyncSuccessCalls} {...props} />
                <AdminRoute path="/admin-newregisteredpatients" exact component={AsyncNewRegisteredPatients} {...props} />

                <ConferenceRoute path="/conference/:id" exact component={AsyncConferenceLayout} {...props} />
                <ConferenceRoute path="/doctor-conference/:id/:uid" exact component={AsyncConferenceLayout} {...props} />
                <ConferenceRoute path="/conference-settings/:id" exact component={AsyncConferenceSettings} {...props} />
                <ConferenceRoute path="/doc-conf-settings/:id/:uid" exact component={AsyncConferenceSettings} {...props} />
                <ConferenceRoute path="/waiting-room/:id" exact component={AsyncWaitingRoom} {...props} />
                <ConferenceRoute path="/test" exact component={AsyncTestSettings} {...props} />
                <ConferenceRoute path="/guest-conference/:id" exact component={AsyncConferenceLayout} {...props} />
            </Switch>
        </Router>
    );
};

export default Routes;
